<!-- 优惠卡券 -->
<template>
  <div class="about" v-cloak>
    <van-nav-bar :border="false" left-arrow fixed :title="document.title" class="about_nav_bar" @click-left="onClickLeft" :z-index="20" :style="'background: #2998FF; color:#FFFFFF;'"></van-nav-bar>

    <!-- <div class="header-video">
      <div class="video"> 
        <video controls="controls" width='100%' height='100%' id="player" allowscriptaccess="always" src="../../assets/video/about.mp4" type="video/x-ms-asf-plugin" autostart="false"></video>
      </div>
    </div> -->

    <!-- <h3 class="list-tips">智慧共享洗车</h3> -->

        <!--  <div class="center-b"  >
 <p>智慧共享洗车是徐州洛美汽车服务有限公司旗下的高端自助洗车项目。公司位于矿业大学科技城，致力于打造集洗车、养护、维修、配货、广告等多项业务的大型综合平台。该项目是国内首创“物联”技术自助洗车的项目之一，并在业内做到技术领跑的地位，公司是一家从产品结构、硬件、软件设计到信息化管理服务一条龙的综合型实体公司。</p>
      <p><b>一、项目及设备介绍</b></p>
      <p><b>（一）项目简介</b></p>
      <p>智慧共享洗车项目以节能环保为前提，提倡技术创新，是业内为数不多的一家能为广大用户和加盟方提供一站式配套服务的项目。智慧自助洗车站，整体由洗车场+便民服务区+公益广告区等部分功能区构成。</p>
      <p>智慧自助洗车站采用线上线下精准管理方式落地运营，站点设计建设融入城市整体规划，绿色环保，解决传统洗车场脏乱差、成本高、消费高、模式陈旧等痛点。我们采取合伙人模式，在全国各省市居民小区、加油站、宾馆、大型停车场等开启千城万站战略规划。</p>
      <p><b>（二）设备介绍</b></p>
      <table class="table" border="1" cellspacing="0">
        <caption>BJ-1自助洗车机配置清单</caption>
        <tr align="center">
          <td> 电机品质 </td>
          <td>国产优质</td>
          <td>产品体积</td>
          <td>1801*800*640</td>
        </tr>
        <tr>
          <td align="center">
            <div>配件</div>
          </td>
          <td align="left" colspan="3">①国内排名前十高压水枪②重型机械高强度防轧高压管③国内著名黑猫品牌泵（飞驰泵）④驰名品牌PVC管⑤高端定制款防震泡沫箱⑥高口碑防水吸尘器⑦行业精品高强度接头⑧定制品牌LED高亮屏幕⑨定制高端高亮大灯</td>
        </tr>
        <tr>
          <td align="center">基本功能</td>
          <td align="left" colspan="3">清水、泡沫、吸尘、高亮LED、照明大灯</td>
        </tr>
        <tr>
          <td align="center">软件配套及功能</td>
          <td align="left" colspan="3">①人机语音交互；②由近及远自动向客户推送站点，实现即时就近导航；③机器各类故障后台自动精准报修；④客户远程感知机器闲置状态，无需排队；⑤财务报表自动化生成，节省人力成本；⑥关枪即停机，智能合理计费；⑦超时自动结算，减少客户消费顾虑；⑧扫码线上支付，刷脸支付（后期），方便快捷；⑨冬季自动保温功能，无惧严寒正常使用。</td>
        </tr>
        <tr>
          <td align="center">即将开发功能</td>
          <td align="left" colspan="3">加盟自动管理系统、周边门店系统、商城</td>
        </tr>
        <tr>
          <td align="center">出水温度</td>
          <td align="center">常温</td>
          <td align="center">产品毛重</td>
          <td align="center">50KG</td>
        </tr>
        <tr>
          <td align="center">高压水枪</td>
          <td align="center">一把</td>
          <td align="center">工作电压</td>
          <td align="center">220V</td>
        </tr>
        <tr>
          <td align="center">最大功率</td>
          <td align="center">2000W</td>
          <td align="center">移动方式</td>
          <td align="center">万向轮，调整角</td>
        </tr>
        <tr>
          <td align="center">计费方式</td>
          <td align="center">刷卡、扫码</td>
          <td align="center">计费标准</td>
          <td align="center">自行设定</td>
        </tr>
        <tr>
          <td align="center">
            <div>单机用水</div>
          </td>
          <td align="center">
            <div>30L</div>
          </td>
          <td align="center">
            <div>质保</div>
          </td>
          <td align="center">
            <div>一年</div>
          </td>
        </tr>

      </table>

      <img src="../../assets/icon/bjjq1.png" alt="">
      <img src="../../assets/icon/bjjq2.png" alt="">

      <p>机器拥有独家专利，集清水、泡沫、吸尘于一体，融合汽车美容、养护、汽车维修等各项服务，科技含量、智慧程度高。<b>特别是，除洗车服务外，还会拓展汽车后市场代办业务、设置人工洗车、广告、线上产品、场地自动售货等多元化服务；</b> 全国统一建设、运营、服务、管理，投资者托管投资，平台全国统一运营管理。</p>
      <p><b>二、站点建设标准</b></p>
      <p>1、服务主导。公司围绕“方便快捷、省时省力、优惠实惠、周到精准”的服务原则，筹划安排工作和建设，并贯穿日常跟踪服务的方方面面。</p>
      <p>2、尊重用户。公司安排专门的团队，组织拟进入小区用户相关行为问题和满意度的调查与研究，小区内投诉率低于5％。公司负责对不满意居民解释和思想工作，取得对方理解和支持。</p>
      <p>3、建设达标。①采用红外高清摄像设备实施24小时监控、配齐安装符合国家安全标准的防火防电等安防设施；②严格按照《徐州市城市管理条例》规定建设用水、排水、去污等环保设施；③设备建造采用先进水泵，噪音低至与流水声同频，不影响周边居民。</p>
      <p>4、管理规范。①公司配备专业管理团队对各站点实施精细管理；②后台软件能够监控至每台设备用电、用水安全状态：③现场员工经过专业管理培训，随时现场解决各类问题；④公司巡查巡视人员每天监督巡查点位环境卫生和人员设备安全管理等情况；⑤每周组织安全风险评估和落实预防措施，确保管理常态化、制度化、无死角、无盲区。</p> 

    </div> -->
    <p class="center-b" v-html="document.content"></p>
 

    <!-- <div class="foot-qrCode">
      <div class="qrCode">
        <img src="../../assets/about/qrcode.png" alt="">
      </div>

      <div class="addss">
        <p>公司地址：徐州市泉山区三官庙7-57#</p>
        <p>全国服务热线：400-762-8588</p>
        <p>公司电话：0516-83799109</p>
      </div>
    </div> -->

  </div>
</template>

<script type="text/babel">
import wx from "weixin-js-sdk";
export default {
  name: "about",
  components: {},
  props: {},
  data() {
    return {
      document: {
        title: "",
        content: undefined,
      },
    };
  },
  watch: {},
  created() {},
  mounted() {
    // this.$toast.loading();
    this.getInit();
  },
  methods: {
    getInit() {
      let _this = this;
      let data = {
        alias: "ABOUTUS",
      };
      _this.$post("/api/document", data, data).then((res) => {
        console.log(res.data, "关于我们");
        // this.$toast.clear();
        if (res.data && res.data.code == 0) {
          this.document.title = res.data.data.title;
          this.document.content = this.formatRichText(res.data.data.content);
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },

    formatRichText(html) {
      /*
       * 处理富文本里的图片宽度自适应
       * 1.去掉img标签里的style、width、height属性
       * 2.img标签添加style属性：max-width:100%;height:auto
       * 3.修改所有style里的width属性为max-width:100%
       * 4.去掉<br/>标签
       * @param html
       * @returns {void|string|*}
       */ 
      let newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
        match = match
          .replace(/style="[^"]+"/gi, "")
          .replace(/style='[^']+'/gi, "");
        match = match
          .replace(/width="[^"]+"/gi, "")
          .replace(/width='[^']+'/gi, "");
        match = match
          .replace(/height="[^"]+"/gi, "")
          .replace(/height='[^']+'/gi, "");
        // match = match
        //   .replace(/src="([^"]+)"/gi, 'src="http://xiche.yiro.top$1"')
        //   .replace(/src='([^']+)'/gi, 'src="http://xiche.yiro.top$1"');
        return match;
      });
      newContent = newContent.replace(
        /style="[^"]+"/gi,
        function (match, capture) {
          match = match
            .replace(/width:[^;]+;/gi, "max-width:100%;")
            .replace(/width:[^;]+;/gi, "max-width:100%;");
          return match;
        }
      );
      // newContent = newContent.replace(/<br[^>]*\/>/gi, '');
      newContent = newContent.replace(
        /\<img/gi,
        '<img style="max-width:100%;height:auto;display:inline-block;"'
      );

      //去除table的宽度
      newContent = newContent.replace(
        /<table[^>]*>/gi,
        function (match, capture) {
          return match.replace(/width=\"(.*)\"/gi, "");
        }
      );

      //去除text-indent
      newContent = newContent.replace(
        /style="[^"]+"/gi,
        function (match, capture) {
          match = match
            .replace(/text-indent:[^;]+;/gi, "text-indent:0")
            .replace(/text-indent:[^;]+;/gi, "text-indent:0");
          return match;
        }
      );



      return newContent;

      // 
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.about_nav_bar {
  .van-nav-bar__content {
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
}
.about {
  // 空状态
  .custom-image .van-empty__image {
    width: 260px;
    height: 300px;
  }
}
</style>

<style lang="scss" scoped>
.about {
  height: 100%;
  width: 100%;
  padding: 50px 0;
  background-color: #2998ff;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  background-image: url("../../assets/about/about-bg.png");
  background-repeat: no-repeat;
  background-position: 0 50px;
  background-size: 100% 420px;

  .header-video {
    margin: 15px;
    padding: 10px;
    background: #ffffff;
    border-radius: 10px;
    .video {
      height: 182px;
      width: 100%;
      video {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }

  .list-tips {
    font-size: 32px;
    font-family: YouSheBiaoTiHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 24px;
    text-shadow: 1px 2px 0px #0f52de;

    text-align: left;
    padding: 10px 15px 0;
  }
}

.center-b {
  padding: 15px;
  font-size: 13px;
  text-align: left;
  p {
    text-indent: 2em;
  }
  img {
    display: block;
    width: 100%;
  }
}


// .foot-qrCode {
//   margin: 15px;
//   padding: 10px;
//   //   background-color: #fff;

//   display: flex;
//   justify-content: space-around;
//   align-items: center;

//   .qrCode {
//     width: 70px;
//     height: 100%;
//     img {
//       display: block;
//       width: 100%;
//       height: 70px;
//     }
//   }
//   .addss {
//     text-align: left;
//     font-size: 13px;
//     font-family: Source Han Sans CN;
//     font-weight: 400;
//     // color: #333333;
//     color: #ffffff;
//     line-height: 24px;
//   }
// }
.click:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}
.table {
  width: 100%;

  td div {
    width: 75px;
  }
}
</style>
